module.exports = __webpack_public_path__ + "static/1191287609.f495fa1b.jpg";